import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../../modes/normalMode/BundleResourceConfig";
import { backpackOpenType } from "../../../modes/normalMode/config/backpackConst";
import { NormalBackpackI } from "../../../modes/normalMode/manager/DefineInterface";
import NormalGameManager from "../../../modes/normalMode/manager/NormalGameManager";
import pawnShopManager from "../../../modes/normalMode/manager/pawnShopManager";
import BackpackPrefab from "../../../modes/normalMode/prefab/backpack/BackpackPrefab";
import { getOnePawnShopBlemishById, getPawnShopBuyChat, getPawnShopObjByQuality, getpawnShopObjMap, getPawnShopSellOneChat, getPawnShopSellSecondChat } from "./config/pawnShopConfig";
import { pawnShopBackpackObjI, pawnShopGameObjI, pawnShopObjQualityE } from "./const/pawnShopConst";
import pawnShopGameObj from "./pawnShopGameObj";
import pawnShopGameObtain from "./pawnShopGameObtain";
import pawnShopGameQuality from "./pawnShopGameQuality";
import pawnShopGameResult from "./pawnShopGameResult";
import pawnShopRole from "./pawnShopRole";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGame extends cc.Component {

    @property({type:cc.Prefab,displayName:"角色预制体"})
    rolePrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"角色content"})
    roleContent:cc.Node = null;

    @property({type:cc.Node,displayName:"objContent"})
    objContent:cc.Node = null;

    @property({type:cc.Node,displayName:"自己说话节点"})
    meChatNode:cc.Node = null;

    @property({type:cc.Node,displayName:"客人说话节点"})
    otherChat:cc.Node = null;

    @property({type:cc.Node,displayName:"购买的按钮"})
    buyBtnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"出售的按钮"})
    sellBtnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"退出压价的按钮"})
    lowerBtnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"报价节点"})
    offerNode:cc.Node = null;

    @property({type:cc.Label,displayName:"顾客数量文本"})
    lb_RoleCount:cc.Label = null;

    @property({type:cc.Node,displayName:"加钱节点"})
    addNode:cc.Node = null;

    @property({type:cc.Node,displayName:"减钱节点"})
    subNode:cc.Node = null;

    //当前进了多少个人
    currentRoleCount:number = 0;
    //当次可以进多少个人
    maxRoleCount:number = 3;
    //角色节点
    roleNode:cc.Node = null;
    //角色
    role:pawnShopRole = null;
    //当前购买或者出售的物品
    nowObj:pawnShopGameObjI = null;
    //当前购买或者出售的物品的价格
    nowPrice:number = 0;
    //物品节点
    objNode:cc.Node = null;
    //物品脚本
    objScript:pawnShopGameObj = null;

    //购买的物品记录
    buyRecordAry:pawnShopBackpackObjI[] = [];
    //当前购买的物品
    currentBuyObj:pawnShopBackpackObjI = null;

    //角色图片路径
    roleSpPaths:string[] = [
        "assets/pawnShopGame/role/role_1",
        "assets/pawnShopGame/role/role_2",
        "assets/pawnShopGame/role/role_3",
        "assets/pawnShopGame/role/role_4",
        "assets/pawnShopGame/role/role_5",
    ];
    
    qualityWeight:number[] = [
        0.71,
        0.25,
        0.04,
        0
    ]
    
    start(): void {
        this.startApproach();    
        this.updateRoleCount();
    }
    
    //开始进场
    async startApproach(){
        this.nowObj = null;
        this.nowPrice = 0;
        let addRound = this.addOneRound();
        this.updateRoleCount();
        if(!addRound){
            // 进入大结算
            this.showBigClean();
            return;
        }
        this.roleNode = this.getOneRandRole();
        this.roleNode.setParent(this.roleContent);
        this.role = this.roleNode.getComponent(pawnShopRole);
        this.roleNode.x = -500;
        this.role.moveAni();
        this.nowObj = this.getOneRoundObj();
        let obj = this.getNowObjAsPawnShopGameObj();
        this.nowPrice = obj.price;
        // 加载物品预制体
        this.objNode = await this.getOneObjNode(obj.prefabPath);
        this.objScript = this.objNode.getComponent(pawnShopGameObj);
        this.objScript.bindData(this);
        await new Promise<void>(resolve=>{
            cc.tween(this.roleNode).to(2,{x:-200}).call(resolve).start();
        });
        this.role.standAni();
        // 开始说话
        let startChat:string = data_control.getRandItemOfArray(getPawnShopSellOneChat());
        console.log("出售<<<<<<<<<<<<<<<",obj.price);
        startChat = this.conversionChat(startChat,obj.name);
        await this.showChat(this.otherChat,startChat,2,5);
        this.objNode.opacity = 0;
        this.objContent.addChild(this.objNode);
        this.objNode.y = 0;
        cc.tween(this.objNode).to(0.2,{opacity:255}).start();
        // 展示购买与否的按钮
        this.showBuyBtns();
        this.showOfferNode();
        this.updateOfferNode();
        this.canFindBlemish = true;
    }

    //开始退场
    startExit(isShowClean:boolean = false){
        this.canFindBlemish = false;
        this.objNode?.removeFromParent();
        this.objNode?.destroy();
        this.objNode = null;
        this.objScript = null;
        this.role.moveAni();
        this.hideChat(this.meChatNode);
        this.hideChat(this.otherChat);
        this.hideOfferNode();
        this.hideBuyBtns();
        cc.tween(this.roleNode).to(2,{x:-500}).call(()=>{
            this.roleNode.destroy();
            this.roleNode.removeFromParent();
            this.roleNode = null;
            this.role = null;
            if(isShowClean){
                this.showSmallClean();
            }else{
                this.startApproach();
            }
        }).start();
    }

    //获得当前回合需要购买或出售的物品
    getOneRoundObj(){
        let pawnManager:pawnShopManager = NormalGameManager._instance.pawnShopManager;
        let buyPro:number = 0.5;
        //如果没有随机到买而且背包中有物品可以进行出售则直接进入出售
        let randObj:pawnShopGameObjI = null;
        randObj = this.getSellObj();
        return randObj;
    }

    getOneObjNode(objPath:string){
        return new Promise<cc.Node>(resolve=>{
            getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(`prefab/pawnShopGame/obj/${objPath}`,cc.Prefab,(err,prefab:cc.Prefab)=>{
                if(err){
                    console.error("# pawnShopGame.ts 143 加载预制体失败");
                    resolve(null);
                }else{
                    resolve(cc.instantiate(prefab));
                }
            });
        });
    }

    //获得出售的物品
    getSellObj(){
        let randQuality:pawnShopObjQualityE = data_control.getRandIPosByWeights(this.qualityWeight);
        let qualityObjs:pawnShopGameObjI[] = getPawnShopObjByQuality(randQuality);
        let objWeightAry:number[] = [];
        for(let i =0;i<qualityObjs.length;i++){
            let obj = qualityObjs[i];
            let weight:number = obj.weight;
            objWeightAry.push(weight);
        }
        let randObjIndex:number = data_control.getRandIPosByWeights(objWeightAry);
        return qualityObjs[randObjIndex];
    }

    //获得一个随机的角色
    getOneRandRole(){
        let roleSpPath:string = this.roleSpPaths[Math.floor(Math.random() * this.roleSpPaths.length)];
        let roleNode:cc.Node = cc.instantiate(this.rolePrefab);
        roleNode.getComponent(pawnShopRole).setSp(roleSpPath);
        return roleNode;
    }

    /**
     * 将当前的物品转换成 pawnShopGameObj 类型并返回
     */
    getNowObjAsPawnShopGameObj(){
        return this.nowObj;
    }

    //触发一个瑕疵
    openOneBlemish(blemishIndex:number,node:cc.Node){
        //获取当前正在出售或者购买的物品
        let obj = this.getNowObjAsPawnShopGameObj();
        //拿到所有瑕疵
        let blemishAry:string[] = obj.buyFindObjs;
        //通过索引确定瑕疵
        let blemishId = blemishAry[blemishIndex];
        let blemish = getOnePawnShopBlemishById(blemishId);
        //获得瑕疵隐形物品的价格
        let blemishPrice = blemish.influencePrice;
        let influencePrice = this.checkBlemishPrice(blemishPrice,obj);
        //当前的价格减去瑕疵影响的钱
        this.nowPrice += influencePrice;
        //客人说话
        let explain:string = data_control.getRandItemOfArray(blemish.findExplain);
        let priceNode:cc.Node = cc.instantiate(this.offerNode.getChildByName("one").getChildByName("lbPrice"));
        priceNode.setParent(this.offerNode);
        priceNode.color = cc.color(0,255,0);
        let labelPrice:cc.Label = priceNode.getComponent(cc.Label);
        labelPrice.string = `${influencePrice}`;
        let moneyNode:cc.Node = null;
        if(influencePrice < 0){
            moneyNode = cc.instantiate(this.subNode);
        }else{
            moneyNode = cc.instantiate(this.addNode);
        }
        let label:cc.Label = moneyNode.getChildByName("label").getComponent(cc.Label);
        label.string = `${influencePrice < 0 ? influencePrice : `+${influencePrice}`}`;
        moneyNode.active = true;
        moneyNode.setParent(this.node);
        moneyNode.setPosition(this.node.convertToNodeSpaceAR(node.convertToWorldSpaceAR(cc.v2(50,100))));
        cc.tween(moneyNode).by(1,{y:25}).call(()=>{
            moneyNode.destroy();
            moneyNode.removeAllChildren();
        }).start();
        cc.tween(priceNode).by(1,{y:25}).call(()=>{
            priceNode.destroy();
            priceNode.removeFromParent();
        }).start();
        this.updateOfferNode();
        this.showChat(this.otherChat,explain,2,5);
    }

    /**
     * 输入一个数字来获取当前的价格可以抵销的瑕疵的钱
     * @param price 瑕疵影响的价格
     * @param objPrice 物品价格
     */
    checkBlemishPrice(price:number,obj:pawnShopGameObjI){
        let pawnManager:pawnShopManager = NormalGameManager._instance.pawnShopManager;
        let objPrice = obj.price;
        let influencePrice:number = 0;
        let multiple:number = pawnManager.getOneObjMoneyMultiple(obj);
        if(price > 0 && price < 1){
            //百分比
            influencePrice = objPrice * price;
            multiple = 1;
        }else if(price < 0 && price > -1){
            //百分比
            influencePrice = objPrice * price;
            multiple = 1;
        }else{
            //固定数值
            influencePrice = price;
        }
        return influencePrice * multiple;
    }
    
    //加一个回合
    addOneRound(){
        if(this.currentRoleCount >= this.maxRoleCount){
            return false;
        }
        this.currentRoleCount ++;
        return true;
    }

    //转换文案
    conversionChat(chat:string,objName:string){
        let strAry:string[] = [];
        let colorAry:string[] = [];
        let sIndex:number = 0;
        for(let i = 0;i<chat.length;i++){
            let s = chat[i];
            if(s == "&"){
                sIndex ++;
                strAry[sIndex] = `${objName}`;
                colorAry[sIndex] = "#00ff00";
                sIndex ++;
            }else if(s == "$"){
                sIndex ++;
                strAry[sIndex] = `${this.nowPrice}`;
                colorAry[sIndex] = "#FF0000"
                sIndex ++;
            }else{
                if(strAry[sIndex] == null){
                    strAry[sIndex] = "";
                }
                strAry[sIndex] += s;
                colorAry[sIndex] = "#484848"
            }
        }
        let str:string = "";
        for(let i = 0;i<strAry.length;i++){
            let color = colorAry[i];
            str += `<color=${color}>${strAry[i]}</c>`;
        }
        return str;
    }

    //写入一条购买记录
    addOneBuyRecord(objId:string,price:number){
        let one :pawnShopBackpackObjI = {
            id: objId,
            buyPrice: price,
            buyTime: 0,
            canFixCount: 0,
            fixCount: 0
        }
        this.buyRecordAry.push(one);
    }

    //初始化记录
    initRecord(){
        this.buyRecordAry = [];
    }

    //重新开始游戏
    resetGame(){
        // 重新开始游戏
        this.initRecord();
        this.currentRoleCount = 0;
        this.canClickBtn = true;
        this.startApproach();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    //UI相关方法开始

    //更新顾客数量
    updateRoleCount(){
        this.lb_RoleCount.string = `顾客数量:${this.currentRoleCount}/${this.maxRoleCount}`;
    }

    chatAniTime:number = 0.2;

    /**
     * 展示一个对话框
     * @param chatNode 需要展示的对话框节点
     * @param resolveTime 需要完成回调的时间 可用于完成回调或者延迟处理逻辑
     * @param showTime 展示的时间 如果不填则一直显示 填了则会按照时间自动消失
     */
    showChat(chatNode:cc.Node,chat:string,resolveTime:number = 2,showTime:number = 10000000){
        return new Promise<void>(resolve=>{
            cc.Tween.stopAllByTarget(chatNode);
            chatNode.active = true;
            let chatLbNode:cc.Node = chatNode.getChildByName("text");
            let chatLb:cc.RichText = chatLbNode.getComponent(cc.RichText);
            chatLb.string = chat;
            cc.tween(chatNode).to(this.chatAniTime,{scale:1,opacity:255},{easing:cc.easing.backOut}).delay(showTime).call(()=>{
                this.hideChat(chatNode);
            }).start();
            cc.tween(this.node).to(resolveTime,{}).call(resolve).start();
        });
    }

    /**
     * 隐藏一个对话框
     * @param chatNode 需要隐藏的对话框节点 
     */
    hideChat(chatNode:cc.Node){
        cc.tween(chatNode).to(this.chatAniTime,{scale:0,opacity:0},{easing:cc.easing.backIn}).call(()=>{
            chatNode.active = false;
        }).start();
    }

    canClickBtn:boolean = false;

    //展示购买按钮
    showBuyBtns(){
        // 加锁
        this.canClickBtn = true;
        this.buyBtnLayout.active = true;
        this.buyBtnLayout.opacity = 0;
        cc.Tween.stopAllByTarget(this.buyBtnLayout);
        cc.tween(this.buyBtnLayout).to(0.2,{opacity:255}).start();
    }

    //隐藏购买按钮
    hideBuyBtns(){
        // 加锁
        this.canClickBtn = false;
        cc.Tween.stopAllByTarget(this.buyBtnLayout);
        cc.tween(this.buyBtnLayout).to(0.2,{opacity:0}).call(()=>{
            this.buyBtnLayout.active = false;
        }).start();
    }

    //展示出售按钮
    showSellBtns(){
        // 加锁
        this.canClickBtn = true;
        this.sellBtnLayout.active = true;
        this.sellBtnLayout.opacity = 0;
        cc.Tween.stopAllByTarget(this.sellBtnLayout);
        cc.tween(this.sellBtnLayout).to(0.2,{opacity:255}).start();
    }

    //隐藏购买按钮
    hideSellBtns(){
        // 加锁
        this.canClickBtn = false;
        cc.Tween.stopAllByTarget(this.sellBtnLayout);
        cc.tween(this.sellBtnLayout).to(0.2,{opacity:0}).call(()=>{
            this.sellBtnLayout.active = false;
        }).start();
    }

    //展示压价按钮
    showlowerBtns(){
        this.hideBuyBtns();
        cc.Tween.stopAllByTarget(this.lowerBtnLayout);
        this.lowerBtnLayout.active = true;
        this.lowerBtnLayout.opacity = 0;
        cc.tween(this.lowerBtnLayout).to(0.2,{opacity:255}).start();
    }

    //隐藏压价按钮
    hidelowerBtns(){
        this.showBuyBtns();
        cc.Tween.stopAllByTarget(this.lowerBtnLayout);
        cc.tween(this.lowerBtnLayout).to(0.2,{opacity:0}).call(()=>{
            this.lowerBtnLayout.active = false;
        }).start();
    }

    //展示报价节点
    showOfferNode(){
        cc.tween(this.offerNode).to(0.2,{opacity:255}).start();
    }
    //隐藏报价节点
    hideOfferNode(){
        cc.tween(this.offerNode).to(0.2,{opacity:0}).start();
    }

    //更新报价
    updateOfferNode(){
        let labelName:cc.Label = this.offerNode.getChildByName("layout").getChildByName("lbName").getComponent(cc.Label);
        let labelPrice:cc.Label = this.offerNode.getChildByName("one").getChildByName("lbPrice").getComponent(cc.Label);
        labelPrice.string = data_control.getNumberFormat(this.nowPrice);
        labelName.string = this.getNowObjAsPawnShopGameObj().name;
    }

    //展示小结算
    showSmallClean(){
        let url:string = `prefab/pawnShopGame/pawnShopObtain`;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(url,cc.Prefab,(err,prefab:cc.Prefab)=>{
            if(err){
                console.error(err,"# pawnShopGame.ts showSmallClean fail");
                return;
            }
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            node.getComponent(pawnShopGameObtain).bindData(this.currentBuyObj,this);
        });
    }

    //展示大结算
    showBigClean(){
        let url:string = `prefab/pawnShopGame/pawnShopResult`;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(url,cc.Prefab,(err,prefab:cc.Prefab)=>{
            if(err){
                console.error(err,"# pawnShopGame.ts showBigClean fail");
                return;
            }
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            node.getComponent(pawnShopGameResult).bindData(this.buyRecordAry,this);
        }); 
    }

    //展示详细
    showQuality(){
        let url:string = `prefab/pawnShopGame/pawnShopQuality`;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.pawnShopGameBundle).load(url,cc.Prefab,(err,prefab:cc.Prefab)=>{
            if(err){
                console.error(err,"# pawnShopGame.ts pawnShopQuality fail");
                return;
            }
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            node.getComponent(pawnShopGameQuality).bindData(this.getNowObjAsPawnShopGameObj());
        }); 
    }

    //UI相关方法结束

    //按钮相关的方法开始
    
    //跳过当前的顾客
    onBtnJump(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(!this.canClickBtn){
            return;
        }
        this.canClickBtn = false;
        this.startExit();
    }

    //买下当前物品
    async onBtnBuy(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // 展示小结算
        if(!this.canClickBtn){
            return;
        }
        if(O1HD.getServices().userSrv.getCoins() < this.nowPrice){
            O1HD.getModules().uiControlModule.showMessageBox("钱不够");
            return;
        }
        O1HD.getServices().userSrv.setCoins(-this.nowPrice,true,this.node);
        this.addOneBuyRecord(this.getNowObjAsPawnShopGameObj().id,this.nowPrice);
        this.canClickBtn = false;
        this.currentBuyObj = NormalGameManager._instance.pawnShopManager.addOneObj(this.getNowObjAsPawnShopGameObj(),this.nowPrice);
        this.startExit(true);
    }

    canFindBlemish:boolean = false;

    //寻找瑕疵
    onBtnFindBlemish(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if(!this.canFindBlemish){
            O1HD.getModules().uiControlModule.showMessageBox("现在还不可以压价");
            return;
        }
        if(!this.objScript || !this.objScript.isValid){
            O1HD.getModules().uiControlModule.showMessageBox("当前没有物品可以压价");
            return;
        }
        this.showlowerBtns();
        this.objScript?.openGlass();
    }

    //点击详细
    onBtnDetailed(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.showQuality();
    }

    //选择物品
    async onBtnSelect(){
        let url = "backpack/backpackPrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
        if(prefab){
            let backpack = cc.instantiate(prefab);
            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.stall,null,(back)=>{
                let item = back as NormalBackpackI;
                let id = item.id;
                let obj = getpawnShopObjMap()[id];
                let meChat = data_control.getRandItemOfArray(getPawnShopSellSecondChat());
                meChat = this.conversionChat(meChat,obj.name);
                this.showChat(this.meChatNode,meChat,2,5);
                this.hideSellBtns();
            },()=>{},(item:NormalBackpackI)=>{
                let id = item.id;
                let obj = getpawnShopObjMap()[id];
                return obj.name == this.nowObj.name;
            });
            backpack.setParent(O1HD.Canvas());
        }
    }

    //退出压价
    onBtnExitLower(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.hidelowerBtns();
        this.objScript?.closeGlass();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

    //按钮相关的方法结束

}
